import { Row, Col } from "react-flexbox-grid";
import { SingleCardCar } from "components/Vehicle";
import Typography from "@material-ui/core/Typography";

export const VehicleListViewCard = ({ data = [], to }) => {
  if (!data.length) {
    return (
      <Row center="xs" className="w-100">
        <Col md={12} className="m-default">
          <Typography variant="body1">
            Aún no has agregado tu primer vehículo
          </Typography>
        </Col>
      </Row>
    );
  }

  return (
    <Row className="w-100">
      {data.map(({ _id, nickName, plates, pictures }) => (
        <SingleCardCar
          key={_id}
          to={`${to}/${_id}`}
          title={`${nickName}, placas: ${plates}`}
          pictures={pictures}
        />
      ))}
    </Row>
  );
};
